import { type BigDecimal, createBigDecimal } from '@0xtorch/big-decimal'
import type { Primitive, ZodLiteral } from 'zod'
import { z } from 'zod'

type MappedZodLiterals<T extends readonly Primitive[]> = {
  -readonly [K in keyof T]: ZodLiteral<T[K]>
}

export const createUnionSchema = <
  T extends readonly [Primitive, Primitive, ...Primitive[]],
>(
  literals: T,
): z.ZodUnion<MappedZodLiterals<T>> =>
  z.union(literals.map((value) => z.literal(value)) as MappedZodLiterals<T>)

export const bigDecimalTextSchema = z
  .string()
  .regex(/^\d+(\.\d+)?$/)
  .transform((v) => createBigDecimal(v))

export const bigDecimalSchema = z
  .object({
    value: z.bigint(),
    decimals: z.number().int(),
  })
  .transform((v): BigDecimal => v)
